import { IFutureExtended } from "../components/PairSpreadItem/PairSpreadItem";
import { ISecurityExtended } from "../models/finam";

export interface IAmounts {
    baseCount: number;
    baseLots: number;
    futCount: number;
    futLots: number;
    profit: number;
}

export const defAmounts = { baseCount: 0, baseLots: 0, futCount: 0, futLots: 0, profit: 0 };

export const calcAmounts = (base: ISecurityExtended, actualFuture: IFutureExtended, deposit: number): IAmounts => {
    if (!base.price)
        return defAmounts;

    const marginPerc = actualFuture.initialMarginPercent;
    const k = marginPerc / (100 + marginPerc);
    const baseDepositAmount = deposit * (1 - k);
    
    const futCount = Math.floor(baseDepositAmount / (actualFuture.price?.bid ?? 0));
    const futLots = futCount / actualFuture.lotSize;

    const baseCount = Math.floor(futCount * actualFuture.num);
    const baseLots = baseCount / base.lotSize;

    const profit = Math.floor(actualFuture.spreadRate * (baseCount * base.price?.ask) * 100) * 0.01;

    const result = {
        baseCount,
        baseLots,
        futCount,
        futLots,
        profit
    };

    return result;
}